import moment from 'moment'
import Types from '../types'
import LocalDatabase from '../../utils/LocalDatabase'

const auth = {
  state: {
    token: null,
    expiresIn: null,
    authUserRole: null,
    user: null,
    gceToken: null,
    gceExpiresIn: null,
    gceUser: null
  },
  getters: {
    getToken(state) {
      return state.token
    },
    getGceToken(state) {
      return state.gceToken
    },
    getGceExpiresIn(state) {
      return state.gceExpiresIn
    },
    getAuthUserRole(state) {
      return state.authUserRole
    },
    getUser(state) {
      return state.user
    },
    getGceUser(state) {
      return state.gceUser
    }
  },
  mutations: {
    [Types.mutations.SET_USER_TOKEN](state, payload) {
      state.token = payload.access_token
      state.expiresIn = payload.expires_in
      state.authUserRole = payload.user.roles
      state.user = payload.user
    },
    [Types.mutations.SET_GCE_USER_TOKEN](state, payload) {
      state.gceToken = payload.access_token
      state.gceExpiresIn = payload.expires_in
      state.gceUser = {
        application_id: payload.application_id
      }
    },
    [Types.mutations.SET_AUTH_RESET](state) {
      state.token = null
      state.expiresIn = null
      state.authUserRole = null
      state.user = null
    },
    [Types.mutations.SET_GCE_AUTH_RESET](state) {
      state.gceToken = null
      state.gceExpiresIn = null
      state.gceUser = null
    },
    async [Types.mutations.RESTORE_GCE_TOKEN](state) {
      const token = await LocalDatabase.get(Types.localdb.GCE_USER_TOKEN)
      const expiresIn = await LocalDatabase.get(Types.localdb.GCE_EXPIRES_IN)
      const user = await LocalDatabase.get(Types.localdb.GCE_USER)
      if (token && expiresIn && user) {
        state.gceToken = token
        state.gceExpiresIn = expiresIn
        state.gceUser = user
        state.authUserRole = 'GCE_USER'
      }
    }
  },
  actions: {
    async [Types.actions.UPDATE_USER_TOKEN]({ commit }, payload) {
      await LocalDatabase.set(Types.localdb.EXPIRES_IN, payload.expires_in)
      await LocalDatabase.set(Types.localdb.USER_TOKEN, payload.access_token)
      await LocalDatabase.set(Types.localdb.USER_ROLE, payload.user.roles)
      await LocalDatabase.set(Types.localdb.USER, payload.user)
      commit(Types.mutations.SET_USER_TOKEN, {
        ...payload
      })
    },
    async [Types.actions.UPDATE_AUTH_RESET]({ commit }) {
      commit(Types.mutations.SET_AUTH_RESET)
    },
    async [Types.actions.UPDATE_GCE_AUTH_RESET]({ commit }) {
      commit(Types.mutations.SET_GCE_AUTH_RESET)
    },
    async [Types.actions.UPDATE_GCE_USER_TOKEN]({ commit }, payload) {
      await LocalDatabase.set(Types.localdb.GCE_EXPIRES_IN, payload.expires_in)
      await LocalDatabase.set(Types.localdb.GCE_USER_TOKEN, payload.access_token)
      await LocalDatabase.set(Types.localdb.GCE_USER, {
        application_id: payload.application_id
      })
      commit(Types.mutations.SET_GCE_USER_TOKEN, {
        ...payload
      })
    },
    async [Types.actions.RESTORE_GCE_TOKEN]({ commit }) {
      commit(Types.mutations.RESTORE_GCE_TOKEN)
    }
  }
}

export default auth
